module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.$style.root
  }, [_c('span', {
    staticClass: "creative-status",
    attrs: {
      "data-statuscode": _vm.creative.status
    }
  }, [_vm._v("CREATIVE STATUS: " + _vm._s(_vm.statusName))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-59714fd8"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/lab/creative-status/CreativeStatus.vue
// module id = 2048
// module chunks = 1